import { render, staticRenderFns } from "./psn.vue?vue&type=template&id=d6be64bc"
import script from "./psn.vue?vue&type=script&lang=js"
export * from "./psn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports